import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconOnaReset: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M7.16663 1L9.49996 3.16667L7.16663 5.33333" stroke="currentColor" strokeLinecap="square" />
                    <path d="M8.83333 10.6666L6.5 12.8333L8.83333 15" stroke="currentColor" strokeLinecap="square" />
                    <path
                        d="M7.16663 12.8334H9.33329C12.0027 12.8334 14.1666 10.6695 14.1666 8.00009C14.1666 6.54348 13.5222 5.23734 12.503 4.3512"
                        stroke="currentColor"
                        strokeLinecap="square"
                    />
                    <path
                        d="M8.83337 3.16663H6.66671C3.99733 3.16663 1.83337 5.33059 1.83337 7.99996C1.83337 9.45689 2.47801 10.7633 3.49763 11.6494"
                        stroke="currentColor"
                        strokeLinecap="square"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path
                            d="M7.16663 1L9.49996 3.16667L7.16663 5.33333"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path
                            d="M8.83333 10.6666L6.5 12.8333L8.83333 15"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path
                            d="M7.16663 12.8334H9.33329C12.0027 12.8334 14.1666 10.6695 14.1666 8.00009C14.1666 6.54348 13.5222 5.23734 12.503 4.3512"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path
                            d="M8.83337 3.16663H6.66671C3.99733 3.16663 1.83337 5.33059 1.83337 7.99996C1.83337 9.45689 2.47801 10.7633 3.49763 11.6494"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path
                            d="M7.16663 1L9.49996 3.16667L7.16663 5.33333"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path
                            d="M8.83333 10.6666L6.5 12.8333L8.83333 15"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path
                            d="M7.16663 12.8334H9.33329C12.0027 12.8334 14.1666 10.6695 14.1666 8.00009C14.1666 6.54348 13.5222 5.23734 12.503 4.3512"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path
                            d="M8.83337 3.16663H6.66671C3.99733 3.16663 1.83337 5.33059 1.83337 7.99996C1.83337 9.45689 2.47801 10.7633 3.49763 11.6494"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                    </g>
                </svg>
            );
    }
};
